import * as TagManager from '@farmnet/tag-manager';
import { InjectionToken } from '@angular/core';

export const TAG_MANAGER = new InjectionToken<TagManager>('tag-manager', {
  providedIn: 'root',
  factory: () => TagManager,
});
